import { DateTime } from 'luxon'
import { isEmpty, isNotDefined } from '@terros/common'

export function formatDollar(value: number | undefined): string {
  if (isEmpty(value)) return ''
  const num = value.toString().substring(0, 9)
  if (num.length < 4) return num
  if (num.length < 7) {
    const comma = num.length - 3
    return `${num.substring(0, comma)},${num.substring(comma)}`
  }
  const comma = num.length - 6
  return `${num.substring(0, comma)},${num.substring(comma, comma + 3)},${num.substring(comma + 3)}`
}

export function formatBytes(size?: number): string {
  if (size === undefined) return 'Unknown size'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let unitIndex = 0
  while (size > 1024) {
    size /= 1024
    unitIndex++
  }
  return `${size.toFixed(2)} ${units[unitIndex]}`
}

export const formatDate = (value: number, options?: { format?: string }): string => {
  return DateTime.fromMillis(value).toFormat(options?.format ?? 'MMM d, yyyy hh:mm a ZZZZ')
}

export const formatOptionalDate = (
  value: number | undefined,
  options?: { format?: string; fallback?: string }
): string => {
  if (isNotDefined(value)) return options?.fallback ?? ''
  return formatDate(value, options)
}

export function formatExcelDate(value: number): string {
  return DateTime.fromMillis(value).toFormat('yyyy-MM-dd HH:mm:ss')
}

export function formatCurrency(input: string): string {
  const cleanedInput = input.replace(/[^\d.]/g, '')
  const [integerPart, decimalPart = ''] = cleanedInput.split('.')

  const trimmedIntegerPart = integerPart.replace(/^0+/, '') || '0'
  const formattedIntegerPart = trimmedIntegerPart.replace(/\B(?=(?:\d{3})+(?!\d))/g, ',')

  const limitedDecimalPart = decimalPart.slice(0, 2)

  return `$${formattedIntegerPart}${limitedDecimalPart || input.endsWith('.') ? '.' : ''}${limitedDecimalPart}`
}

export function formatNumber(input: string): string {
  const cleanedInput = input.replace(/[^\d.]/g, '')
  const [integerPart, decimalPart = ''] = cleanedInput.split('.')

  const trimmedIntegerPart = integerPart.replace(/^0+/, '') || '0'
  const limitedDecimalPart = decimalPart.slice(0, 2)

  return `${trimmedIntegerPart}${limitedDecimalPart || input.endsWith('.') ? '.' : ''}${limitedDecimalPart}`
}

export function formatPhone(value: string | undefined): string {
  if (isEmpty(value)) return ''
  const num = value.replace(/\D/gm, '')
  if (num.length < 4) return num
  if (num.length < 7) return `(${num.substring(0, 3)}) ${num.substring(3)}`
  return `(${num.substring(0, 3)}) ${num.substring(3, 6)}-${num.substring(6, 10)}`
}

export const toEmptyValueIfDefault = (value: string | undefined, defaultValue: string): string => {
  if (isNotDefined(value)) return ''
  if (value === defaultValue) return ''
  return value
}
